import { FC, ReactNode } from 'react';
import clsx from 'clsx';
import { Typography } from '../Typography';

export interface PageHeroNotification {
  message: string;
  actionLabel?: string;
  onAction?: () => void;
}

export interface PageHeroProps {
  children: ReactNode;
  notification?: PageHeroNotification;
  className?: string;
}

const innerContainer = 'md:max-w-[600px] lg:max-w-[846px] mx-auto w-full px-[--padding-md] sm:px-0';

export const PageHero: FC<PageHeroProps> = ({ children, notification, className }) => (
  <div className={clsx('w-full flex flex-col', className)}>
    <div className="bg-[--page-header-bg-grey] w-full">
      <div
        className={clsx(innerContainer, 'pt-[--padding-xl] pb-[--padding-md] sm:py-[--padding-xl]')}
      >
        {children}
      </div>
    </div>
    {notification && (
      <div className="bg-white w-full">
        <div className={clsx(innerContainer, 'py-[--padding-md] sm:py-[--padding-xl]')}>
          <div className="flex items-center gap-[--padding-md] bg-[--color-grey-200] rounded-[--corner-xs] px-[--padding-md] py-[--padding-2xs]">
            <Typography variant="paragraph010" className="flex-1 text-[--page-header-header]">
              {notification.message}
            </Typography>
            {notification.actionLabel && (
              <button type="button" onClick={notification.onAction} className="shrink-0">
                <Typography variant="button020" className="text-[--color-blue-200]">
                  {notification.actionLabel}
                </Typography>
              </button>
            )}
          </div>
        </div>
      </div>
    )}
  </div>
);
